import { initializeApp } from 'firebase/app';
import config from './config';
import { getFunctions } from 'firebase/functions';

export const app = initializeApp(config);
export const functions = getFunctions(app, 'europe-west2');
